import shopifyClient from '../shopify-client';

async function handleBuilderFormSubmit(e) {
  e.preventDefault();
  const cartForm = document.querySelector('form[action="/cart/add"][id*="product_form"]');
  const product = JSON.parse(cartForm.parentElement.dataset.product);
  const formData = new FormData(cartForm);
  const option0Value = formData.get('option-0');
  const option1Value = formData.get('option-1');
  const { id } = product.variants.find((variant) => {
    if (option1Value) {
      return variant.option1 === option0Value && variant.option2 === option1Value;
    }
    return variant.option1 === option0Value;
  });
  try {
    const { success } = await shopifyClient.add({
      items: [
        {
          id,
          quantity: 1,
        },
      ],
    });

    if (success) {
      window.location.href = '/checkout';
    }

    if (!success) {
    }
  } catch (error) {}
}

export default handleBuilderFormSubmit;
